import React, { useState } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";

const VIDEOS = [
  {
    label: "Athlete Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/ATHLETEBOOSTVIDEO.mp4?alt=media&token=f7619800-2650-47b9-905a-944dbede78b8",
  },
  {
    label: "Fan Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/FANBOOSTVIDEO.mp4?alt=media&token=07c181ba-3f49-4d1a-817c-c71b43dfd6b9",
  },
  {
    label: "Fan Manager Boost Explainer",
    url: "https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/MANAGERBOOSTVIDEO.mp4?alt=media&token=24a8f554-5742-4750-b363-0f8f42beb943",
  },
];

const VisibilityExplainerVideos = () => {
  const [activeVideo, setActiveVideo] = useState(null);

  return (
    <>
      <div
        style={{
          border: "1.5px solid #d0d8f5",
          borderRadius: "20px",
          padding: "24px 24px 22px",
          backgroundColor: "#eef2ff",
          textAlign: "center",
          maxWidth: "360px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <p style={{ fontWeight: "800", fontSize: "18px", color: "#111", marginBottom: "16px" }}>
          Visibility Board Explainer Videos
        </p>

        {/* Buttons in same column */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%", flex: 1, justifyContent: "center" }}>
          {VIDEOS.map((video, idx) => (
            <button
              key={idx}
              className="btn btn-primary"
              style={{ fontSize: "12px", padding: "14px 12px", borderRadius: "12px", width: "100%", whiteSpace: "normal" }}
              onClick={() => setActiveVideo(video)}
            >
              {video.label}
            </button>
          ))}
        </div>
      </div>

      {/* Video Modal */}
      <Modal isOpen={!!activeVideo} toggle={() => setActiveVideo(null)} centered size="lg">
        <ModalHeader
          toggle={() => setActiveVideo(null)}
          style={{ borderBottom: "none", paddingBottom: 0 }}
        >
          {activeVideo?.label}
        </ModalHeader>
        <ModalBody className="p-2">
          {activeVideo && (
            <video
              src={activeVideo.url}
              controls
              autoPlay
              style={{ width: "100%", borderRadius: "8px", maxHeight: "70vh" }}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default VisibilityExplainerVideos;
